<template>
  <el-dialog :title="dialogTitle" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="是否启用">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
        <span style="margin-left: 10px;">{{ form.isEnable ? '启用' : '禁用' }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doSubmit()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import diseaseApi from '@/api/sys/disease'

function initFormBean() {
  const formBean = {
    id: null,
    name: '',
    isEnable: false
  }
  return formBean
}

export default {
  props: {
    rowItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      dialogTitle: '新增',
      formRules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }]
      },
      isRepSub: false
    }
  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate() {
      this.resetForm()
      this.dialogTitle = '新增'
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.dialogTitle = '编辑'
      this.form = {
        id: row.id || null,
        name: row.name || '',
        isEnable: row.isEnable !== undefined ? row.isEnable : false
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          this.isLoading = true

          const params = {
            name: this.form.name,
            isEnable: this.form.isEnable
          }

          if (this.form.id) {
            // 编辑模式 - 使用 PUT 请求
            params.id = this.form.id
            diseaseApi.update(params).then(() => {
              this.postCallback()
            }).catch(res => {
              this.isRepSub = false
              this.isLoading = false
              this.$common.showMsg('error', '操作失败，请重试')
            })
          } else {
            // 新增模式 - 使用 POST 请求
            diseaseApi.create(params).then(() => {
              this.postCallback()
            }).catch(res => {
              this.isRepSub = false
              this.isLoading = false
              this.$common.showMsg('error', '操作失败，请重试')
            })
          }
        }
      })
    },
    postCallback() {
      this.isRepSub = false
      this.isLoading = false
      this.$common.showMsg('success', '操作成功')
      this.formVisible = false
      this.$emit('created')
    }
  }
}
</script>

<style scoped>
::v-deep .el-select {
  width: 100%;
}
</style>

